import "./style.css";

export const buttonCOntainer =
  "flex justify-end buttonContainer text-[#4ADE80] ";

export const addButton =
  "addButton bg-[#4ADE80] border-[#4ADE80] dark:hover:border-white dark:hover:bg-white hover:text-[#4ADE80] hover:bg-[#4ADE80] ";
export const addIcon =
  "icon text-white hover:text-white dark:hover:text-[#4ADE80]";
